/**
 * Strategies Page
 *
 * Contains the climate strategies index.
 */

import React from 'react';
import {inject, observer} from 'mobx-react';
import {Link} from 'react-router-dom';
import { PiFilePdf } from "react-icons/pi";

import ContentPage from '../../components/ContentPage';

function openPdfInNewWindow(pdfUrl, page) {
    if (page) {
        pdfUrl = `${pdfUrl}#page=${page}`
    }
    const newWindow = window.open(pdfUrl, "_blank", "noopener,noreferrer")
    if (!newWindow) {
        console.error(
            "Failed to open new window. Please check if the popup blocker is enabled."
        )
    }
}


class ReportLinks extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            expanded: false,
        };
    }

    handleClick = () => {
        this.setState((prevState) => ({
            expanded: !prevState.expanded,
        }));
    };

    renderExpandedContent() {
        const {strategyData} = this.props;
        return (
            <ul>
                {strategyData.reports.map(r => <li className={'sub-link-item'} onClick={(e) => {
                    e.stopPropagation();
                    this.openPdf(r.pdfName)
                }}><PiFilePdf color={'#999999'}/> {r.name}</li>)}
            </ul>
        );
    }

    render() {
        const {strategyData, category} = this.props;
        const {expanded} = this.state;

        return (
            <li className={'link-item'} onClick={this.handleClick}
                style={{cursor: "pointer", background: category.color}}>
                {strategyData.displayName}
                {expanded && this.renderExpandedContent()}
            </li>
        );
    }

    openPdf(pdfName) {
        openPdfInNewWindow('./pdf/' + pdfName);
    }


}

@inject('store')
@observer
class StrategiesPage extends React.Component {

    render() {
        const {categorizedThreats: threats, serialize} = this.props.store;

        return (
            <ContentPage className="StrategiesPage">
                <div className="header">
                    <h1>Find Strategies</h1>
                    Click on a threat below to find potential solutions for your park.
                </div>

                <ul className="strategies">
                    {Object.entries(threats).map(([categoryTitle, category]) => (
                        <li key={categoryTitle}>
                            <h2 style={{color: category.color}}>{categoryTitle}</h2>

                            <ul className="strategy-list">
                                {Object.keys(category.strategies).map(strategy => {
                                    const strategyData = category.strategies[strategy];
                                    if (strategyData?.reports) {
                                        return <ReportLinks key={strategy} category={category}
                                                            strategyData={strategyData}/>
                                    } else {
                                        return <li key={strategy}>
                                            <Link className={'link-item'} to={`/strategies/${serialize(strategy)}`}
                                                  style={{background: category.color}}>
                                                {strategyData?.displayName || strategy}
                                            </Link>
                                        </li>
                                    }
                                })}
                            </ul>
                        </li>
                    ))}
                </ul>
            </ContentPage>
        );
    }

}


export default StrategiesPage;
